var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InnerLoader',{staticClass:"payment-loading",staticStyle:{"top":"0","left":"0"},attrs:{"z-index":999}})
}
var staticRenderFns = []

export { render, staticRenderFns }